import type { Messages } from "@prop/i18n";
import type en from "../en/admin";

export default {
  title: "Админка",
  lead: "Операции деска: люди, деньги, риск и сама платформа.",
  mfaGate: "Для админки нужна двухэтапная проверка. Добавьте второй фактор в разделе «Безопасность» и, если попросит, войдите заново.",
  toSecurity: "Открыть «Безопасность»",
  tabs: {
    users: "Пользователи",
    audit: "Журнал аудита",
    settings: "Настройки",
    jobs: "Задачи",
    errors: "Ошибки",
    data: "Данные рынка",
  },
  common: {
    search: "Найти",
    reason: "Причина (попадёт в журнал аудита)",
    save: "Сохранить",
    cancel: "Отмена",
    empty: "Пока пусто",
    loadMore: "Показать ещё",
    actions: "Действия",
  },
  users: {
    searchPlaceholder: "E-mail, имя или @telegram",
    email: "E-mail",
    telegramOnly: "Только Telegram",
    name: "Имя",
    roles: "Роли",
    status: "Статус",
    mfa: "2FA",
    lastLogin: "Последний вход",
    active: "Активен",
    blocked: "Заблокирован",
    block: "Заблокировать",
    unblock: "Разблокировать",
    signOut: "Завершить все сессии",
    editRoles: "Роли",
    rolesHint: "Нужен суперадмин с ключом безопасности. Чтобы роли применились, пользователь будет разлогинен.",
  },
  audit: {
    action: "Действие",
    actor: "Кто",
    target: "Объект",
    when: "Когда",
    reason: "Причина",
    verify: "Проверить цепочку хешей",
    chainOk: { one: "Цепочка цела: проверена {count} запись", few: "Цепочка цела: проверено {count} записи", many: "Цепочка цела: проверено {count} записей", other: "Цепочка цела: проверено {count} записи" },
    chainBroken: "Цепочка нарушена на записи {id}",
    filterAction: "Действие начинается с",
  },
  settings: {
    default: "по умолчанию",
    changed: "Изменил {who}, {when}",
    saved: "Сохранено",
  },
  jobs: {
    name: "Задача",
    last: "Последний запуск",
    status: "Статус",
    lastOk: "Последний успех",
    failures: "Сбоев за 24 ч",
    none: "Запусков пока нет: задачи выполняет процесс worker.",
  },
  data: {
    instrument: "Инструмент",
    source: "Источник",
    status: "Статус",
    book: "Книга",
    age: "Возраст котировки",
    lag: "Задержка",
    resyncs: "Ресинки",
    adapters: "Источники",
    connected: "подключён",
    disconnected: "нет соединения",
    reconnects: { one: "{count} переподключение", few: "{count} переподключения", many: "{count} переподключений", other: "{count} переподключения" },
    live: "Работает",
    closed: "Закрыт (вне сессии)",
    noData: "Нет данных",
    replay: "REPLAY",
    reasons: { syncing: "синхронизация", stale: "устарела", resyncing: "пересинхронизация", no_data: "нет источника данных" },
    unavailable: "md-gateway не отвечает.",
  },
  roles: {
    trader: "Трейдер",
    affiliate: "Партнёр",
    support: "Поддержка",
    risk_analyst: "Риск-аналитик",
    risk_manager: "Риск-менеджер",
    payments_operator: "Оператор выплат",
    payments_approver: "Утверждающий выплаты",
    compliance: "Комплаенс",
    product_admin: "Администратор продукта",
    finance: "Финансы",
    superadmin: "Суперадмин",
  },
  settingKeys: {
    marketData_staleMsCrypto: "Порог устаревшей котировки, крипта",
    marketData_staleMsFx: "Порог устаревшей котировки, FX/CFD",
    marketData_staleMsFutures: "Порог устаревшей котировки, фьючерсы",
    payouts_newAddressDelayHours: "Задержка выплаты на новый кошелёк",
    payouts_reserveRatio: "Резерв выплат с каждой продажи (доля цены)",
    risk_breachReviewHours: "Окно разбора после нарушения",
    risk_fundingCapPerPersonUsd: "Финансирование на трейдера, все программы",
    payouts_cryptoAddressTtlMinutes: "Срок жизни крипто-адреса оплаты",
    payouts_checkoutTtlMinutes: "Срок оплаты заказа картой",
    payouts_cryptoConfirmations: "Нужно подтверждений сети",
    payouts_underpayTolerancePct: "Допуск недоплаты в крипто",
    payouts_affiliateRatePct: "Комиссия партнёра по умолчанию",
    payouts_withdrawalMinUsd: "Минимальный вывод с баланса",
    payouts_withdrawalFeeTronUsd: "Комиссия сети при выводе, TRON",
    payouts_withdrawalFeeEthereumUsd: "Комиссия сети при выводе, Ethereum",
    offers_bonusActivationPct: "Активация бонуса без Turbo (доля от цены покупки)",
    offers_resetPricePct: "Сброс после нарушения (доля от цены покупки)",
    offers_breachCouponPct: "Купон после нарушения (скидка на следующую покупку)",
    offers_breachCouponDays: "Купон после нарушения: дней действия",
    platform_demoBanner: "Баннер тестового режима на всех страницах",
  },
  units: {
    ms: "мс",
    hours: "ч",
  },
  errors: {
    message: "Ошибка",
    count: "Раз",
    lastSeen: "Последний раз",
    resolve: "Исправлено",
    showResolved: "Показать исправленные",
  },
} satisfies Messages<typeof en>;
